import React, {Component} from 'react';
import classes from './Generator.css'
import Dropdown from '../../components/Dropdown/Dropdown'
import Dice from '../../components/Dice/Dice';
import axios from 'axios';
import logo from '../../assets/logo-head.svg';

class Generator  extends Component {
    state = {
        result: null,
        isLoading: false
    }

    onDropdownChangedHandler = (event) => {
        this.setState({
            isLoading: true
        })
        switch(event.target.value) {
            case "colleague": 
                axios.get("https://rando-generator.firebaseio.com/colleagues.json")
                    .then(res=>{
                        this.setRandomResult(res.data)
                    });
                break;
            case "object": 
                axios.get("https://rando-generator.firebaseio.com/objects.json")
                    .then(res=>{
                        this.setRandomResult(res.data)
                    });
                break;
            case "room": 
                axios.get("https://rando-generator.firebaseio.com/rooms.json")
                    .then(res=>{
                        this.setRandomResult(res.data)
                    });
                break;
            case "lunch": 
                axios.get("https://rando-generator.firebaseio.com/lunch.json")
                    .then(res=>{
                        this.setRandomResult(res.data)
                    });
                break;
            case "framework": 
                axios.get("https://rando-generator.firebaseio.com/frameworks.json")
                    .then(res=>{
                        this.setRandomResult(res.data)
                    });
                break;
            case "neighbor": 
                axios.get("https://rando-generator.firebaseio.com/neighbors.json")
                    .then(res=>{
                        this.setRandomResult(res.data)
                    });
                break;
            case "americans": 
                axios.get("https://rando-generator.firebaseio.com/americans.json")
                    .then(res=>{
                        this.setRandomResult(res.data)
                    });
                break;
            case "number": this.setState({
                    isLoading: false,
                    result: this.generateNumber(0,100)
                }) 
                break;
            default: return null;
        }
    }

    generateNumber = (min, max) => {
        return Math.floor(Math.random() * max) + min  
    }

    setRandomResult = (response) => {
        //Turn object into array of values
        const result = Object.keys(response).map(el => {
            return response[el]
        })

        //Randomly generated index
        const key = this.generateNumber(0, result.length - 1);
        
        this.setState({
            result: result[key],
            isLoading: false
        })
    }

    render(){
        const options = [{
            value: "",
            placeholder: "Избери..."
        },{
            value: "colleague",
            placeholder: "Случаен колега от офиса"
        },{
            value: "object",
            placeholder: "Случаен предмет от офиса"
        },{
            value: "room",
            placeholder: "Случайна стая от офиса"
        },{
            value: "lunch",
            placeholder: "Случаен обяд"
        },{
            value: "framework",
            placeholder: "Случаен JS framework"
        },{
            value: "neighbor",
            placeholder: "Случаен съсед до офиса"
        },{
            value: "americans",
            placeholder: "Случайно американче"
        },{
            value: "number",
            placeholder: "Случайно число"
        }]

        return (
            <div className={classes.Generator}>
                <div className={classes.Wrapper}>
                    <div className={classes.LogoHolder}>
                        <img src={logo} className={classes.Logo} alt="logo" />
                    </div>
                    <h1 className={classes.Heading}>Избери ми </h1>
                    <Dropdown options={options} changed={this.onDropdownChangedHandler}/>
                    <Dice roll={this.state.isLoading}/>
                    <p className={classes.Result}>{this.state.result}</p>
                </div>
            </div>
        )
    }
} 

export default Generator;


// WEBPACK FOOTER //
// ./src/containers/Generator/Generator.js